<template>
    <div>

        <div>
            <v-form
                ref="login_associate"
                v-model="valid_associate_login"
            >  

                <div class="max-w-[550px] mx-auto my-2">
                    <registration-title title="Login">
                    </registration-title>
                    <div>
                        <v-text-field
                        :rules="disable_rules ? [] : [validation_rules.required, validation_rules.email]"
                        :label="$t('E-mail')"
                        outlined
                        dense
                        v-model="email"
                        ></v-text-field>
                        <v-text-field
                        :rules="disable_rules ? [] : [validation_rules.required]"
                        :label="$t('Password')"
                        type="password"
                        outlined
                        dense
                        v-model="password"
                        ></v-text-field>
                        <div class="grid grid-cols-1 gap-[.5rem] divide-y divide-grey">
                        <div class="pb-[1rem]">
                            <v-btn color="primary" :loading="isLoading" dark block @click="submitForm">{{$t('Login')}}</v-btn>
                        </div>
                        <div class="flex justify-between pt-[.5rem]">
                            <!-- <small><a class="block text-center" @click="tab = 'create'">{{$t('Crea account')}}</a></small> -->
                            <small><a class="block text-center" @click="routerTarget('registration')">{{$t('Crea account')}}</a></small>
                            <small><a class="block text-center" @click="routerTarget('password')">{{$t('Password dimenticata?')}}</a></small>

                            <!-- <small><a class="block text-center" @click="tab = 'reset'">{{$t('Password dimenticata?')}} -->
                            <!-- <small><a class="block text-center" @click="$router.replace('/login/password')">{{$t('Password dimenticata?')}} -->
                            
                        </div>
                        
                        </div>
                        
                        <v-progress-linear
                        v-if="isLoading"
                        color="primary"
                        indeterminate
                        ></v-progress-linear>
                    </div>
                </div>

            </v-form>

            <div class="mt-2">
                <v-alert type="error" @click="handleError" v-if="error">{{
                    error
                }}</v-alert>
            </div>
            </div>

    </div>
</template>

<script>
export default {
    name: "TheLogin",
    data() {
        return {
            error: null,
            disable_rules: true,
            email: "",
            password: "",
            isLoading: false,
            valid_associate_login: true,
        };
    },
    methods: {
        routerTarget(target){
            let main_path = this.$route.meta.from == 'agency' ? '' : '-models'
            this.$router.replace({ path: `/login${main_path}/${target}` });
        },
        async submitForm() {
            this.disable_rules =  false
            await this.delay(200)
            let valid = await this.$refs.login_associate.validate();
            if(valid){

                this.isLoading = true;

                const actionPayload = {
                email: this.email,
                password: this.password,
                };

                try {
                await this.$store.dispatch("login", actionPayload);
                await this.$store.dispatch("user/loadUser");
                const redirectUrl = this.$route.query.target ?? "/account/data";
                this.$router.replace(redirectUrl);
                } catch (err) {
                this.error = err.message || "Failed to authenticate, try later.";
                this.isLoading = false;
                }
                this.isLoading = false;
            
            }
        },
        handleError() {
            this.error = null;
        },
    },
}
</script>

<style lang="scss" scope>
/*  */
</style>